module.exports = __webpack_public_path__ + "static/media/default_thumbnail_853_480.a3601189.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbnail/default_thumbnail_853_480.jpg
// module id = 313
// module chunks = 2